export type EventTag = 'careers' | 'founders' | 'ai' | 'community';

export interface Event {
  start: string;
  end?: string;
  time?: string;
  title: string;
  where: string;
  desc: string;
  tags: EventTag[];
  url: string;
  free?: boolean;
  pick?: boolean;
}

export const EVENTS: Event[] = [
  {
    start: '2026-09-29',
    title: 'Monzo × BTF: Pitch Perfect',
    where: 'Liverpool Street, London',
    desc: 'A Black Tech Fest warm-up with Monzo. Careers, recruiters and networking with people from Monzo, Bloomberg, Just Eat and more. Needs a BTF ticket.',
    tags: ['careers', 'community'],
    url: 'https://luma.com/colori-v45e'
  },
  {
    start: '2026-09-30',
    end: '2026-10-01',
    title: 'Sifted Summit 2026',
    where: 'Protein Studios, Shoreditch',
    desc: 'One of Europe\'s biggest startup and scaleup events. Founders, operators and investors, 200+ speakers and a lot of networking.',
    tags: ['founders'],
    url: 'https://summit.sifted.eu/2026-tickets'
  },
  {
    start: '2026-10-01',
    title: 'Black Women in Tech Summit 2026',
    where: 'London',
    desc: 'A full-day summit for Black women in technology, covering AI, cyber, cloud, product, data, digital transformation and leadership.',
    tags: ['community', 'careers', 'ai'],
    url: 'https://theblackwomenintech.com/black-women-in-tech-summit-2026/'
  },
  {
    start: '2026-10-02',
    end: '2026-10-11',
    title: 'Deep Tech Week London',
    where: 'Venues across London',
    desc: '20+ events on deep tech, AI and science, for founders, investors and researchers.',
    tags: ['founders', 'ai'],
    url: 'https://www.deeptech.london/'
  },
  {
    start: '2026-10-07',
    end: '2026-10-08',
    title: 'AI Breakthrough Conference',
    where: 'Convene Bishopsgate',
    desc: 'Enterprise AI, agentic AI, automation and GenAI, for a more senior business audience.',
    tags: ['ai'],
    url: 'https://www.thehackettgroup.com/ai-conference-eu2026/'
  },
  {
    start: '2026-10-08',
    title: 'Deep Tech London Summit',
    where: 'Shoreditch',
    desc: 'The main summit of Deep Tech Week, bringing together founders, VCs, scientists and emerging tech.',
    tags: ['founders', 'ai'],
    url: 'https://www.deeptech.london/'
  },
  {
    start: '2026-10-09',
    time: '1:30 to 4:30pm',
    title: 'London STEM Women Graduate Careers Event',
    where: 'QEII Centre, Westminster',
    desc: 'Meet STEM employers and network. Best for students and recent graduates.',
    tags: ['careers', 'community'],
    url: 'https://www.stemwomen.com/event/london-stem-women-graduate-careers-event-october-2026'
  },
  {
    start: '2026-10-12',
    title: 'Colorintech ColorCode',
    where: 'London and online',
    desc: 'Workshops and employers for people at the start of their tech careers, from the team behind Black Tech Fest.',
    tags: ['careers', 'community'],
    url: 'https://www.joinbtf.com/ccode'
  },
  {
    start: '2026-10-12',
    end: '2026-10-16',
    title: 'Women in Tech Week',
    where: 'London, UK-wide and online',
    desc: '100+ events across the week on careers, technology and leadership.',
    tags: ['careers', 'community'],
    url: 'https://women-in-tech-week.com/'
  },
  {
    start: '2026-10-12',
    end: '2026-10-17',
    title: 'UK Black Business Week',
    where: 'London',
    desc: 'A six-day programme on entrepreneurship, tech, finance, careers and leadership.',
    tags: ['founders', 'community'],
    url: 'https://www.blackbusinessexperience.com/uk-black-business-week/2026-agenda'
  },
  {
    start: '2026-10-13',
    title: 'Black Women Business Talks',
    where: 'London',
    desc: 'Black women founders and professionals on business growth, careers and leadership. Part of UK Black Business Week.',
    tags: ['founders', 'community'],
    url: 'https://www.blackbusinessexperience.com/uk-black-business-week/2026-agenda'
  },
  {
    start: '2026-10-14',
    title: 'Black STEM Careers Fair',
    where: 'London',
    desc: 'Black STEM talent meets employers. Part of UK Black Business Week.',
    tags: ['careers', 'community'],
    url: 'https://www.blackbusinessexperience.com/uk-black-business-week/2026-agenda'
  },
  {
    start: '2026-10-14',
    title: 'Black Tech Experience',
    where: 'London',
    desc: 'For Black professionals and leaders already working in tech. Part of UK Black Business Week.',
    tags: ['community'],
    url: 'https://www.ukblackbusinessweek.com/bbw-anchor-events/black-tech-experience'
  },
  {
    start: '2026-10-16',
    title: 'AI Advantage: Building Your Edge',
    where: 'London',
    desc: 'A practical session on using AI commercially and in your career. Part of UK Black Business Week.',
    tags: ['ai', 'community'],
    url: 'https://www.blackbusinessexperience.com/uk-black-business-week/2026-agenda'
  },
  {
    start: '2026-10-16',
    title: 'TechWomen100 Awards',
    where: 'Mansion House, London',
    desc: 'Awards celebrating women in tech, with senior-level networking.',
    tags: ['community'],
    url: 'https://wearetechwomen.com/tw100-women-in-tech-awards/techwomen100-awards-ceremony-2026/'
  },
  {
    start: '2026-10-17',
    time: '9am to 6pm',
    title: 'UK Black Business Show',
    where: 'ExCeL London',
    desc: 'A huge day of entrepreneurs, careers, tech, exhibitors and networking. 10th anniversary edition.',
    tags: ['founders', 'community', 'careers'],
    url: 'https://www.eventbrite.co.uk/e/uk-black-business-show-2026-tickets-1982201664538'
  },
  {
    start: '2026-10-20',
    end: '2026-10-21',
    title: 'AI LIVE London',
    where: 'Olympia London',
    desc: 'Enterprise AI: GenAI, automation, governance and putting it into production.',
    tags: ['ai'],
    url: 'https://www.olympia.co.uk/events/ai-live'
  },
  {
    start: '2026-10-22',
    time: '4 to 8pm',
    title: 'Foundervine: The Foundry Showcase Day 1.0',
    where: 'Foundervine Spaces, Canada Water',
    desc: 'Founders pitch live after a 12-week accelerator, run with Molten Ventures and Esprit Foundation. Investor and founder networking.',
    tags: ['founders'],
    free: true,
    pick: true,
    url: 'https://www.foundervine.com/events'
  },
  {
    start: '2026-10-27',
    title: 'Black Monzo: From Presence to Progression',
    where: 'Liverpool Street, London',
    desc: 'Black Monzo\'s Black History Month event. Around 200 Black professionals, career conversations, the hiring team and free headshots.',
    tags: ['careers', 'community'],
    url: 'https://luma.com/5ttlhpn3'
  },
  {
    start: '2026-10-29',
    time: '9am to 10pm',
    title: 'Black Tech Fest 2026',
    where: 'Tobacco Dock',
    desc: 'A major Black tech, founder and investor event powered by Colorintech, with an afterparty.',
    tags: ['community', 'founders', 'careers'],
    url: 'https://www.joinbtf.com/'
  },
  {
    start: '2026-10-30',
    time: '2 to 7pm',
    title: 'Foundervine: Wray Forward Conference',
    where: 'London',
    desc: 'Black founders, investors and experts on AI, funding, e-commerce and brand building, with founder showcases.',
    tags: ['founders', 'community', 'ai'],
    url: 'https://www.foundervine.com/our-programmes/wray-forward-conference'
  },
  {
    start: '2026-11-09',
    end: '2026-11-12',
    title: 'Web Summit 2026',
    where: 'Lisbon, Portugal',
    desc: 'One of the biggest tech conferences in the world. Worth the trip if you\'re building or raising.',
    tags: ['founders', 'ai'],
    url: 'https://websummit.com/web-summit-2026/'
  },
  {
    start: '2026-11-19',
    time: '6 to 9pm',
    title: 'Foundervine: Immerse Pitch & Cocktails Night',
    where: 'Lloyds Banking Group, Leeds',
    desc: 'Founders pitch to investors with funding on the table. Pitch applications close 19 October.',
    tags: ['founders'],
    url: 'https://www.foundervine.com/events'
  },
  {
    start: '2026-12-02',
    title: 'Foundervine: Wray Forward Pitch & Rum Punch',
    where: 'Campari HQ, London',
    desc: 'Founders pitch to investors and industry leaders for grant funding.',
    tags: ['founders', 'community'],
    url: 'https://www.foundervine.com/events'
  },
  {
    start: '2026-12-08',
    title: 'Foundervine: The Foundry Showcase Day 2.0',
    where: 'London',
    desc: 'The second Foundry cohort presents its progress and pitches for funding.',
    tags: ['founders'],
    url: 'https://www.foundervine.com/events'
  },
];

export const TAG_LABELS: Record<EventTag, string> = {
  careers: 'Breaking in',
  founders: 'Founders',
  ai: 'AI',
  community: 'Community'
};

export const FILTER_LABELS: Record<EventTag | 'all', string> = {
  all: 'All',
  careers: 'Breaking into tech',
  founders: 'Founders & investors',
  ai: 'AI',
  community: 'Black & women in tech'
};

export const BRAGBOOQ_URL = 'https://bragbooq.com';

// Helper functions
export const parseDate = (dateStr: string): Date => {
  return new Date(dateStr + 'T00:00:00');
};

export const getUpcomingEvents = (events: Event[]): Event[] => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return events
    .filter(e => parseDate(e.end || e.start) >= today)
    .sort((a, b) => parseDate(a.start).getTime() - parseDate(b.start).getTime());
};

export const getPastEvents = (events: Event[]): Event[] => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return events
    .filter(e => parseDate(e.end || e.start) < today)
    .sort((a, b) => parseDate(b.start).getTime() - parseDate(a.start).getTime()); // Most recent first
};

export const getPickEvent = (events: Event[]): Event | undefined => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return events.find(e => e.pick && parseDate(e.end || e.start) >= today);
};

export const groupEventsByMonth = (events: Event[]): Map<number, Event[]> => {
  const groups = new Map<number, Event[]>();

  events.forEach(e => {
    const date = parseDate(e.start);
    const key = date.getFullYear() * 100 + date.getMonth();
    const existing = groups.get(key) || [];
    groups.set(key, [...existing, e]);
  });

  return groups;
};

export const getMonthName = (key: number): string => {
  const months = ['January', 'February', 'March', 'April', 'May', 'June',
                  'July', 'August', 'September', 'October', 'November', 'December'];
  return months[key % 100];
};

export const getShortMonthName = (date: Date): string => {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return months[date.getMonth()];
};

export const getWeekdayShort = (date: Date): string => {
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  return days[date.getDay()];
};
